import { formatDate } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';

import { SCHEDULED_SHOW_DATE_FORMAT, TIME_FORMAT } from './constants';

export const getInitials = (name?: string) => {
  if (!name) {
    return 'UN';
  }
  const secondWord = name.split(' ')[1];
  return `${name[0].toUpperCase()}${secondWord[0].toUpperCase()}`;
};

export const isEmptyObject = (
  object?: Record<string, unknown> | null,
): boolean => {
  if (!object) {
    return true;
  }

  return Object.keys(object).length === 0;
};

const addZero = (value?: number) => {
  if (!value) {
    return '00';
  }

  return value < 10 ? `0${value}` : value;
};

export const formatDuration = (timeLeft: number) => {
  const days = Math.floor(timeLeft / 86400);
  const hours = Math.floor((timeLeft % 86400) / 3600);
  const minutes = Math.floor((timeLeft % 3600) / 60);
  const seconds = Math.floor(timeLeft % 60);

  if (days > 0) {
    return `${days}d ${addZero(hours)}:${addZero(minutes)}:${addZero(seconds)}`; // DDd HH:MM:SS
  }

  if (hours > 0) {
    return `${addZero(hours)}:${addZero(minutes)}:${addZero(seconds)}`; // HH:MM:SS
  }

  return `${addZero(minutes)}:${addZero(seconds)}`; // MM:SS
};

export const getDateTimeString = (date?: Date | string) => {
  if (!date) {
    return '';
  }
  return `${formatDate(
    new Date(date),
    SCHEDULED_SHOW_DATE_FORMAT,
  )} @ ${formatDate(new Date(date), TIME_FORMAT)}`;
};

export const formatNumber = (value: number, floatValue = 0) => {
  const COMPARED_NUMBER_K = 999;
  const COMPARED_NUMBER_M = 999999;
  const THOUSAND = 1000;
  const MILLION = 1000000;
  const ADDED_VALUE_K = 'K';
  const ADDED_VALUE_M = 'M';

  if (value > COMPARED_NUMBER_M) {
    return `${(value / MILLION).toFixed(floatValue)}${ADDED_VALUE_M}`;
  }

  if (value > COMPARED_NUMBER_K) {
    return `${(value / THOUSAND).toFixed(floatValue)}${ADDED_VALUE_K}`;
  }

  return value;
};

export const getListenersText = (count: number) => {
  return `${count ? formatNumber(count, 0) : '0'} listener${count === 1 ? '' : 's'}`;
};

export const generateAnonymousUserId = (): string => uuidv4();

export const getFlagURIByCountryCode = (code?: string) => {
  if (!code) {
    return;
  }

  return `https://flagcdn.com/w80/${code?.toLowerCase()}.png`;
};
